const init = (options) => {
  const myPromise = new Promise((resolve, reject) => {
    if (window.gtmDidInit) {
      return false;
    }
    window.gtmDidInit = true; // flag to ensure script does not get added to DOM more than once.
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    document.head.appendChild(script);
    script.onload = function () {
      // console.log('GTM loaded --- Via Script Tag');
      // console.log('Checking GTM INIT -- in Script Tag', window.gtmDidInit);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "gtm.js",
        "gtm.start": new Date().getTime(),
        "gtm.uniqueEventId": 0
      });
      resolve();
    };

    script.src = `https://www.googletagmanager.com/gtm.js?id=${options.gtmID}`;
    document.head.appendChild(script);

    return false;
  });

  return myPromise;
};

export { init };
